export default "__VITE_ASSET__csnTFwhU__"